import React from 'react';
import GridTable from "../../../../common/components/core/GridTable";
import {useTransfersContext} from "../TransfersContext";
import styles from './TransfersGrid.module.scss';
import {FormattedMessage} from "react-intl";

const TransfersGrid = () => {
  const {tableTransfers} = useTransfersContext();

  return (
    <div className={styles.tableContainer}>
      <GridTable
        table={tableTransfers}
        emptyLabel={(
          <div className={styles.empty}>
            <FormattedMessage
              id={'transfers-grid-list-empty'}
              defaultMessage={'There are no transfers found to display'}
            />
          </div>
        )}
        customClassname={{
          container: styles.table,
          row: styles.row,
          header: styles.head
        }}
      />
    </div>
  )
};

export default TransfersGrid;
